import React from "react";
import Button from "./Button";
import { BUTTONS_LIST } from "../utils/contants";
import { useDispatch, useSelector } from "react-redux";
import { changeSearchButton } from "../utils/appSlice";

const ButtonList = () => {
  const dispatch = useDispatch();
  const searchButton = useSelector((store)=> store.app.searchButton);

  const toggleSearchButton =(button)=>{
    dispatch(changeSearchButton(button));
  }

  return (
    <div className="flex flex-wrap ml-6 my-20 w-screen">
          <button className="px-10 py-2 m-2 bg-orange-200 rounded-lg">{searchButton}</button>
      {BUTTONS_LIST.map((button)=>
        <button onClick={()=>{toggleSearchButton(button)}} className="px-5 py-2 m-2 bg-gray-200 rounded-lg" key ={button}>{button}</button>
      )}
      {/* <Button name="All" />
      <Button name="Songs" />
      <Button name="Live" />
      <Button name="Soccer" />
      <Button name="Cricket" />
      <Button name="Cooking" />
      <Button name="Cricket" />
      <Button name="Valentines" />
      <Button name="Cricket" />
      <Button name="Cooking" />
      <Button name="Cricket" /> */}
    </div>
  );
};

export default ButtonList;
